import { isSequenceApiError, isSequenceApiErrorResponse } from '@sequencehq/api'

export const getCustomerAliasError = (
  error: unknown
): { hasError: boolean; identifiers: string[] } => {
  if (
    !isSequenceApiError(error) ||
    !isSequenceApiErrorResponse(error.response)
  ) {
    return { hasError: false, identifiers: [] }
  }

  const customerAliasError = error.response?.error.errors.find(
    ({ key }) => key === 'customerAliases'
  )

  if (!customerAliasError) {
    return { hasError: false, identifiers: [] }
  }

  const aliasesRegex = customerAliasError.message.match(/\[([^\]]+)\]/)

  const identifiers =
    aliasesRegex && aliasesRegex[1]
      ? aliasesRegex[1].split(', ').map(a => a.trim())
      : []

  return {
    hasError: true,
    identifiers
  }
}
